"use client";
import { useState, useEffect } from "react";

import PropTypes from "prop-types";

import PastTime from "assets/svg/past-time.svg";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";
import { stringToSlug } from "helpers/string-to-slug";

import Container from "components/grid/container";
import ShowcaseTabWrapper from "components/homepage/showcase-tab-wrapper";
import Button from "components/common/button";

import styles from "./styles.module.css";

const Showcase = ({ categoryTree }) => {
  const [lastTwoSearchStorage, setLastTwoSearchStorage] = useState([]);
  const [lastSearch, setLastSearch] = useState(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setLastTwoSearchStorage(JSON.parse(localStorage.getItem("last-two-search")) || []);
      setLastSearch(localStorage.getItem("lastSearch") || null);
    }
  }, []);

  const handleLastSearchButtonClick = (url) => {
    const lastSearchGa4EventLabel = stringToSlug(url, "-");
    Ga4WithEventParameters({
      eventName: "click_widget",
      eventParameters: { widget: `son-aramalar||${lastSearchGa4EventLabel}` },
    });
    window.location = url;
  };

  return (
    <>
      <div className={styles.showcaseImageWrapper}>
        <img src="/assets/images/showcase.webp" alt="head_image" className={styles.showcaseImage} />
      </div>
      <div className={styles.wrapper}>
        <Container>
          <div className={styles.inner}>
            <h1 className={styles.title}>{`${lastSearch || "Satılık Ev"} Arıyorsan Çözüm Net: Emlakjet`}</h1>
            <ShowcaseTabWrapper categoryTree={categoryTree} />
            <div className={styles.buttonwrapper}>
              {lastTwoSearchStorage.length > 0 &&
                lastTwoSearchStorage.map((item, index) => (
                  <div className={styles.btnwidth} key={index}>
                    <Button
                      onClick={() => handleLastSearchButtonClick(item?.url)}
                      size="Auto"
                      buttonClass={styles.btn}
                      outline
                    >
                      <PastTime />
                      <span className={styles.buttontitle}>{item?.name}</span>
                    </Button>
                  </div>
                ))}
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

Showcase.propTypes = {
  categoryTree: PropTypes.any,
};

export default Showcase;
